import { FC, useEffect } from 'react';

import { useHistory } from 'react-router';

import { GridColumn, GridLayout, GridRow } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';
import { useDashboardRoute } from 'hooks/useDashboardRoute';

import { AccountsControl } from 'components/AccountsControl/AccountsControl';
import { AccountCreateButton } from 'components/AccountsControl/components/AccountCreateButton';
import { PageContentHeader } from 'components/common/PageContentHeader/PageContentHeader';
import { Header } from 'components/Header/Header';

import { SessionType } from 'store/models/user';
import { useSelector } from 'store/utils';

const TrlKeys = {
    title: 'accounts.control.title',
    backLink: 'accounts.control.backLink',
};

export const AccountsControlPage: FC = () => {
    const isSudo = useSelector((state) => state.user.sessionType === SessionType.Sudo);
    const history = useHistory();
    const dashboardRoute = useDashboardRoute();

    const trl = useTrls();

    useEffect(() => {
        if (!isSudo) {
            history.replace('/new/forbidden/');
        }
    }, [isSudo, history]);

    if (!isSudo) {
        return null;
    }

    return (
        <>
            <Header />
            <PageContentHeader
                title={trl(TrlKeys.title)}
                breadcrumbsConfig={[
                    { to: dashboardRoute, children: trl(TrlKeys.backLink) },
                    { to: '#', children: trl(TrlKeys.title) },
                ]}
                vSpacingBottom={24}
                rightContent={<AccountCreateButton />}
            />
            <GridLayout>
                <GridRow>
                    <GridColumn xs={4} s={8} m={12} l={12}>
                        <AccountsControl />
                    </GridColumn>
                </GridRow>
            </GridLayout>
        </>
    );
};
